import { useQuery } from 'react-query';

import { fetchPaddleCheckoutPlans } from '@/api/billing/fetchPaddleCheckoutPlans';
import queryKeys from '@/modules/shared/query/queryKeys';

export function usePaddleCheckoutPlans() {
  return useQuery({
    queryKey: [queryKeys.paddleCheckoutPlans],
    queryFn: fetchPaddleCheckoutPlans,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}
